import template from './edit-notification-type.html';

class EditNotificationTypeVM
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.editing = ko.observable(false);
		this.notification_type_id = ko.observable(null);
		this.notification_group = ko.observable('');
		this.notification_name = ko.observable('');
		this.title_template = ko.observable('');
		this.message_template = ko.observable('');
		this.idx = ko.observable(0);
		this.context_fields_text = ko.observable('[]');
		this.channels = ko.observableArray([]);
		this.channel_options = ko.observableArray([]);
	}

	async btnSave_click ()
	{
		const group = (this.notification_group() || '').trim();
		const name = (this.notification_name() || '').trim();

		if (!group || !name)
		{
			Grape.alerts.alert({ type: 'warning', title: 'Validation', message: 'Group and Name are required' });
			return;
		}

		let context_fields = null;
		try
		{
			const text = this.context_fields_text();
			if (text && text.trim().length > 0)
				context_fields = JSON.parse(text);
		}
		catch (e)
		{
			Grape.alerts.alert({ type: 'warning', title: 'Validation', message: 'Context fields must be valid JSON' });
			return;
		}

		const result = await Grape.fetches.postJSON('/api/notifications/notification-type', {
			notification_type_id: this.notification_type_id(),
			notification_group: group,
			notification_name: name,
			title_template: this.title_template(),
			message_template: this.message_template(),
			idx: this.idx() || 0,
			context_fields: context_fields
		});

		if (result.status !== 'OK')
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: result.message || 'Failed to save' });
			return;
		}

		const type_id = result.notification_type_id || this.notification_type_id();
		for (const ch of this.channel_options())
		{
			if (ch.options_text() && ch.options_text().trim().length > 0)
			{
				let opts;
				try { opts = JSON.parse(ch.options_text()); }
				catch (e)
				{
					Grape.alerts.alert({ type: 'warning', title: 'Validation', message: `Invalid JSON for channel ${ch.display_name}` });
					return;
				}

				await Grape.fetches.postJSON('/api/notifications/notification-type-channel', {
					notification_type_id: type_id,
					notification_channel_id: ch.notification_channel_id,
					options: opts
				});
			}
		}

		this.dialog.close(true);
	}

	btnClose_click ()
	{
		this.dialog.close(null);
	}
}

class EditNotificationTypeDialog
{
	constructor (bindings, element)
	{
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new EditNotificationTypeVM(this);
		this.name = 'EditNotificationTypeDialog';
		this.init();
	}

	async init ()
	{
		const channels = this.bindings.channels || [];

		if (this.bindings.notification_type)
		{
			const nt = this.bindings.notification_type;
			this.viewModel.editing(true);
			this.viewModel.notification_type_id(nt.notification_type_id);
			this.viewModel.notification_group(nt.notification_group);
			this.viewModel.notification_name(nt.notification_name);
			this.viewModel.title_template(nt.title_template || '');
			this.viewModel.message_template(nt.message_template || '');
			this.viewModel.idx(nt.idx || 0);
			this.viewModel.context_fields_text(
				nt.context_fields ? JSON.stringify(nt.context_fields, null, 2) : '[]'
			);

			const tc_res = await Grape.fetches.getJSON('/api/record', {
				schema: 'notifications',
				table: 'v_notification_type_channel',
				filter: JSON.stringify([{
					field: 'notification_type_id',
					operand: '=',
					value: nt.notification_type_id
				}])
			});
			const type_channels = tc_res.records || [];
			const tc_map = {};
			for (const tc of type_channels)
				tc_map[tc.notification_channel_id] = tc;

			const ch_opts = channels.map(ch => ({
				notification_channel_id: ch.notification_channel_id,
				display_name: ch.display_name || ch.name,
				options_text: ko.observable(
					tc_map[ch.notification_channel_id]
						? JSON.stringify(tc_map[ch.notification_channel_id].options || {}, null, 2)
						: ''
				)
			}));
			this.viewModel.channel_options(ch_opts);
		}
		else
		{
			this.viewModel.editing(false);
			const ch_opts = channels.map(ch => ({
				notification_channel_id: ch.notification_channel_id,
				display_name: ch.display_name || ch.name,
				options_text: ko.observable('')
			}));
			this.viewModel.channel_options(ch_opts);
		}

		this.viewModel.channels(channels);
	}
}

export default {
	name: 'EditNotificationType',
	dialog_class: EditNotificationTypeDialog,
	template: template,
	provider: 'ps'
}
